import { useEffect } from 'react';

import { usePathname } from 'expo-router';

import { useExperiments } from 'state/experiments';
import { routes } from 'utils/routing';

interface IUseLogMenuExperimentExposureOptions {
  exposureFlagKey: string | undefined;
  exposurePathname?: string;
  isVariantDisplayed: boolean;
}

/** Logs a menu experiment exposure after its assigned variant is displayed on the expected route. */
export const useLogMenuExperimentExposure = ({
  exposureFlagKey,
  exposurePathname,
  isVariantDisplayed,
}: IUseLogMenuExperimentExposureOptions): void => {
  const pathname = usePathname();
  const { exposureRevision, logExposure } = useExperiments();

  useEffect(() => {
    const expectedPathname = exposurePathname ?? routes.menu;
    if (exposureFlagKey && isVariantDisplayed && pathname === expectedPathname) {
      logExposure(exposureFlagKey, { useExperimentVariantKey: true });
    }
  }, [
    exposureFlagKey,
    exposurePathname,
    exposureRevision,
    isVariantDisplayed,
    logExposure,
    pathname,
  ]);
};
